import React from 'react';

export default function({growthMin, setGrowthMin}) {
    const onChange = (e) => {
        setGrowthMin(e.target.value);
    }

    return (
        <div className="flex-row flex-v-center flex-gap-10">
            <div>
                {`Growth Margin:`}
            </div>
            <div className="growth-min-select">
                <select value={growthMin} onChange={onChange}>
                    <option value={5}>{`>= 5%`}</option>
                    <option value={10}>{`>= 10%`}</option>
                    <option value={15}>{`>= 15%`}</option>
                    <option value={20}>{`>= 20%`}</option>
                    <option value={25}>{`>= 25%`}</option>
                    <option value={30}>{`>= 30%`}</option>
                    <option value={35}>{`>= 35%`}</option>
                    <option value={40}>{`>= 40%`}</option>
                    <option value={45}>{`>= 45%`}</option>
                    <option value={50}>{`>= 50%`}</option>
                </select>
            </div>
            <div>
                {`(Data with >= ${growthMin}% growth are highlighted)`}
            </div>
        </div>
    );
}